import React, { useEffect } from 'react';

import { connect } from 'react-redux';
import { socket } from './../../socket';

import {
  addingActiveCollab,
  setBusinessChallenge,
  addIdea,
  selectIdea,
  updateIdea,
  deleteIdea,
  addMilestone,
  addMilestoneConnector,
  updateMilestoneConnectorOrderDBOnly,
  updateMilestoneConnectorOrder,
  updateMilestoneConnector,
  deleteMilestoneConnector,
  addPersona,
  editPersona,
  deletePersona,
  setCountdown,
} from '../../actions';

function SocketListeners(props) {
  useEffect(() => {
    //Timer
    socket.on('onTimerCountdownClient', (data) => {
      props.setCountdown(data.countdown);
    });

    //ActiveCollaborators
    socket.on('onAddActiveCollaboratorClient', (data) => {
      props.addingActiveCollab(data.activeCollaborators);
    });

    //BusinessChallenge

    socket.on('onBusinessChallengeAddClient', (data) => {
      props.setBusinessChallenge(data);
    });

    //Milestone
    socket.on('onMilestoneIdeasAddClient', (data) => {
      props.addIdea(
        data.id,
        data.persona_id,
        data.milestone,
        data.idea,
        data.chosen
      );
    });

    socket.on('onMilestoneIdeasSelectClient', (data) => {
      props.selectIdea(null, data.milestone, data.ideaId, true);
    });

    socket.on('onMilestoneIdeasUpdateClient', (data) => {
      props.updateIdea(null, data.id, data.milestone, data.idea_content);
    });

    socket.on('onMilestoneIdeasDeleteClient', (data) => {
      props.deleteIdea(data.stageName, data.ideaId);
    });

    socket.on('onMilestoneAddClient', (data) => {
      props.addMilestone(data.position, data.id, data.content);
    });

    //MilestoneConnectors
    socket.on('onMilestoneConnectorIdeasAddClient', (data) => {
      props.addIdea(data.id, null, data.milestone, data.idea, data.chosen);
    });

    socket.on('onMilestoneConnectorIdeasUpdateClient', (data) => {
      props.updateIdea(null, data.id, data.milestone, data.idea_content);
    });

    socket.on('onMilestoneConnectorIdeasDeleteClient', (data) => {
      props.deleteIdea(data.stageName, data.ideaId);
    });

    socket.on('onMilestoneConnectorAddClient', (data) => {
      props.addMilestoneConnector(
        data.id,
        data.connector_name,
        data.title,
        data.content
      );

      let connectors = [], connectorName = '';
      if (data.connector_name !== 'keyVar') {
        connectorName = data.connector_name;
      } else {
        connectorName = "key";
      }

      connectors = props.milestones[connectorName].connectorIds;
      connectors.push(data.id);

      props.updateMilestoneConnectorOrderDBOnly(
        props.journeyId,
        connectorName,
        connectors
      );
    });

    socket.on('onMilestoneConnectorUpdateClient', (data) => {
      props.updateMilestoneConnector(
        data.connector_name,
        data.id,
        data.title,
        data.content
      );
    });

    socket.on('onMilestoneConnectorDeleteClient', (data) => {
      let connectors = [], connectorName = '';

      if (data.connector_name === 'keyVar') {
        connectorName = 'key';
      } else {
        connectorName = data.connector_name;
      }

      for (let i = 0; i < props.milestones[connectorName].connectorIds.length; i++) {
        if (data.id !== props.milestones[connectorName].connectorIds[i]) {
          connectors.push(props.milestones[connectorName].connectorIds[i]);
        }
      }

      props.updateMilestoneConnectorOrderDBOnly(
        props.journeyId,
        connectorName,
        connectors
      );

      props.deleteMilestoneConnector(data.id, data.connector_name);
    });

    socket.on('onMilestoneConnectorOrderUpdateClient', (data) => {
      props.updateMilestoneConnectorOrder(data.milestone, data.connectorIds);
    });

    //Personas
    socket.on('onPersonaIdeasAddClient', (data) => {
      props.addIdea(
        data.id,
        data.persona_id,
        data.milestone,
        data.idea,
        data.chosen
      );
    });

    socket.on('onPersonaIdeasDeleteClient', (data) => {
      props.deleteIdea(data.stageName, data.ideaId);
    });

    socket.on('onPersonaIdeasUpdateClient', (data) => {
      props.updateIdea(
        data.personaId,
        data.id,
        data.milestone,
        data.idea_content
      );
    });

    socket.on('onPersonaIdeasSelectClient', (data) => {
      props.selectIdea(
        data.personaId,
        data.milestone,
        data.ideaId,
        data.chosen
      );
    });

    socket.on('onPersonaAddClient', (data) => {
      props.addPersona(
        data.personaId,
        data.name,
        data.role,
        data.hero,
        data.picUrl
      );
    });

    socket.on('onPersonaUpdateClient', (data) => {
      props.editPersona(
        data.personaId,
        data.name,
        data.role,
        data.hero,
        data.picUrl
      );
    });

    socket.on('onPersonaDeleteClient', (data) => {
      props.deletePersona(data);
    });
  }, []);

  return <div></div>;
}

const mapStateToProps = (state) => ({
  journeyId: state.app.journeyId,
  milestones: state.milestones,
});

const mapDispatchToProps = (dispatch) => ({
  //BusinessChallenge
  setBusinessChallenge: (challenge) =>
    dispatch(setBusinessChallenge(challenge)),

  //ActiveCollaborators
  addingActiveCollab: (activeCollaborators) =>
    dispatch(addingActiveCollab(activeCollaborators)),

  //Milestone

  addIdea: (ideaId, personaId, stageName, ideaContent, chosen) =>
    dispatch(addIdea(ideaId, personaId, stageName, ideaContent, chosen)),

  selectIdea: (personaId, stageName, ideaId, chosen) =>
    dispatch(selectIdea(personaId, stageName, ideaId, chosen)),

  updateIdea: (personaId, ideaId, stageName, ideaContent) =>
    dispatch(updateIdea(personaId, ideaId, stageName, ideaContent)),

  deleteIdea: (stageName, ideaId) => dispatch(deleteIdea(stageName, ideaId)),

  addMilestone: (position, id, content) =>
    dispatch(addMilestone(position, id, content)),

  //MilestoneConnectors
  addMilestoneConnector: (journeyId, connectorName, title, content) =>
    dispatch(addMilestoneConnector(journeyId, connectorName, title, content)),

  updateMilestoneConnector: (journeyId, connectorName, title, content) =>
    dispatch(
      updateMilestoneConnector(journeyId, connectorName, title, content)
    ),

  deleteMilestoneConnector: (journeyId, connectorName, title, content) =>
    dispatch(
      deleteMilestoneConnector(journeyId, connectorName, title, content)
    ),

  updateMilestoneConnectorOrderDBOnly: (journeyId, milestone, connectorIds) =>
    dispatch(
      updateMilestoneConnectorOrderDBOnly(journeyId, milestone, connectorIds)
    ),

  updateMilestoneConnectorOrder: (milestone, connectorIds) =>
    dispatch(updateMilestoneConnectorOrder(milestone, connectorIds)),

  //Personas
  addPersona: (personaId, name, role, hero, pic_url) =>
    dispatch(addPersona(personaId, name, role, hero, pic_url)),

  editPersona: (id, name, role, hero, picUrl) =>
    dispatch(editPersona(id, name, role, hero, picUrl)),

  deletePersona: (personaId) => dispatch(deletePersona(personaId)),

  //Timer

  setCountdown: (countdown) => dispatch(setCountdown(countdown)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SocketListeners);
